var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFoxTail = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 55.7742,
    height: 101.473,
    viewBox: "0 0 55.7742 101.473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.76 101.473C40.76 101.473 34.475 101.448 30.025 99.9879C15.395 95.1979 7.43 86.0629 2.475 75.3479C0.714998 71.5479 0 65.0829 0 65.0829C0 65.0829 1.065 66.0729 2.515 67.2079C3.665 68.1079 4.5 68.4029 4.5 68.4029C4.5 68.4029 3.57 66.3729 2.995 63.4079C0.954995 52.9129 3.34999 45.3329 7.89999 37.4879C14.185 26.6529 20.335 22.2679 23.4 13.6129C24.495 10.5129 24.8 8.01791 24.03 5.64791C23.11 2.80791 17.585 0.672913 17.585 0.672913C17.585 0.672913 25.62 -1.94209 35.3 3.13791C40.865 6.05791 45.79 9.83291 48.7 14.0929C55.935 24.6829 56.86 31.4579 54.845 44.1929C52.935 56.2479 45.22 66.3729 42.345 71.5129C41.845 72.4079 40.765 75.3979 40.765 75.9679V101.468L40.76 101.473Z",
    fill: "url(#paint0_linear_0_11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.7,
    d: "M47.9753 27.7927C46.6353 22.8977 45.8103 21.5277 43.0353 17.2777C41.1653 14.4077 39.3553 13.1877 39.3553 13.1877L40.6403 17.0527L41.5653 20.7077C42.0853 21.0477 39.9553 18.1877 36.6803 14.9477C34.3803 12.6727 30.8403 11.1427 30.8403 11.1427C30.8403 11.1427 33.8203 15.4477 35.7303 19.6877C37.6403 23.9277 38.4803 32.8177 38.0503 35.4477C37.2753 40.1977 43.8103 38.3927 46.6803 38.9127C49.5503 39.4327 49.3253 35.5427 47.9703 27.7827L47.9753 27.7927Z",
    fill: "url(#paint1_linear_0_11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.7603 89.5428C39.3503 88.8328 37.9653 88.0628 36.6353 87.2228C33.0003 84.9278 30.1003 82.4728 27.1853 78.7328C25.7903 76.9428 23.7753 72.7578 23.7753 72.7578C23.7753 72.7578 27.7453 76.9178 30.1103 78.5578C32.0903 79.9278 36.5503 81.6678 36.5503 81.6678C36.5503 81.6678 33.0753 78.9278 31.5803 77.4128C27.9953 73.7728 25.3603 69.6078 23.6153 65.1228C20.9603 58.2878 20.3703 50.7128 21.6453 43.1328C22.1353 40.2278 23.9153 34.4628 23.9153 34.4628C23.9153 34.4628 18.4903 39.6328 16.4753 44.6378C13.8603 51.1428 14.1953 58.8828 14.1953 58.8828C14.1953 58.8828 12.6453 56.3428 11.9403 54.8928C11.2903 53.5578 10.6203 50.5528 10.6203 50.5528C10.6203 50.5528 9.64032 54.3878 9.59032 58.7778C9.50032 66.7278 10.6303 72.9278 14.4803 79.7778C17.6503 85.4078 25.5953 91.6028 34.4953 95.4428C36.4103 96.2678 38.5653 96.7928 40.7503 97.1528V89.5478L40.7603 89.5428Z",
    fill: "url(#paint2_radial_0_11)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_11",
    x1: 27.885,
    y1: 0.00791117,
    x2: 27.885,
    y2: 101.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FF9B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FD4835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FB3161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2872"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_11",
    x1: 31.1564,
    y1: 10.5357,
    x2: 43.9861,
    y2: 33.0266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFEB49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFEB49",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEB49",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEB49",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFEB49",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FFEB49",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_0_11",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-61.6947 51.3478) scale(95.455 95.455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE0449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2872",
    stopOpacity: 0.07
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFoxTail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fox-tail.c6f8e99b14d951543be0bd9ade8252fc.svg";